// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IErrorDto,
  IGenericErrorDto,
  IInterestRateTemplateDto,
  IPageInterestRateTemplateDto,
} from '../models/index';
import {
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IInterestRateTemplateDtoFromJSON,
    IInterestRateTemplateDtoToJSON,
    IPageInterestRateTemplateDtoFromJSON,
    IPageInterestRateTemplateDtoToJSON,
} from '../models/index';

export interface FetchActiveInterestRateTemplatesRequest {
    page?: number;
    size?: number;
}

export interface GetInterestRateTemplateByIdRequest {
    templateId: number;
}

export interface GetInterestRateTemplateByIdAndVersionIdRequest {
    templateId: number;
    versionId: number;
}

export interface GetInterestRateTemplateWithLatestVersionByIdRequest {
    templateId: number;
}

/**
 * InterestAccrualServiceServiceApi - interface
 * 
 * @export
 * @interface InterestAccrualServiceServiceApiInterface
 */
export interface InterestAccrualServiceServiceApiInterface {
    /**
     * 
     * @summary Fetch active interest rate templates
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterestAccrualServiceServiceApiInterface
     */
    fetchActiveInterestRateTemplatesRaw(requestParameters: FetchActiveInterestRateTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageInterestRateTemplateDto>>;

    /**
     * Fetch active interest rate templates
     */
    fetchActiveInterestRateTemplates(requestParameters: FetchActiveInterestRateTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageInterestRateTemplateDto>;

    /**
     * 
     * @summary Get existing interest rate template by id
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterestAccrualServiceServiceApiInterface
     */
    getInterestRateTemplateByIdRaw(requestParameters: GetInterestRateTemplateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInterestRateTemplateDto>>;

    /**
     * Get existing interest rate template by id
     */
    getInterestRateTemplateById(requestParameters: GetInterestRateTemplateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInterestRateTemplateDto>;

    /**
     * 
     * @summary Get existing interest rate template by id and version id
     * @param {number} templateId 
     * @param {number} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterestAccrualServiceServiceApiInterface
     */
    getInterestRateTemplateByIdAndVersionIdRaw(requestParameters: GetInterestRateTemplateByIdAndVersionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInterestRateTemplateDto>>;

    /**
     * Get existing interest rate template by id and version id
     */
    getInterestRateTemplateByIdAndVersionId(requestParameters: GetInterestRateTemplateByIdAndVersionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInterestRateTemplateDto>;

    /**
     * 
     * @summary Get interest rate template with latest version by id
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterestAccrualServiceServiceApiInterface
     */
    getInterestRateTemplateWithLatestVersionByIdRaw(requestParameters: GetInterestRateTemplateWithLatestVersionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInterestRateTemplateDto>>;

    /**
     * Get interest rate template with latest version by id
     */
    getInterestRateTemplateWithLatestVersionById(requestParameters: GetInterestRateTemplateWithLatestVersionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInterestRateTemplateDto>;

}

/**
 * 
 */
export class InterestAccrualServiceServiceApi extends runtime.BaseAPI implements InterestAccrualServiceServiceApiInterface {

    /**
     * Fetch active interest rate templates
     */
    async fetchActiveInterestRateTemplatesRaw(requestParameters: FetchActiveInterestRateTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageInterestRateTemplateDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/interest-rate-templates/active`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageInterestRateTemplateDtoFromJSON(jsonValue));
    }

    /**
     * Fetch active interest rate templates
     */
    async fetchActiveInterestRateTemplates(requestParameters: FetchActiveInterestRateTemplatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageInterestRateTemplateDto> {
        const response = await this.fetchActiveInterestRateTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get existing interest rate template by id
     */
    async getInterestRateTemplateByIdRaw(requestParameters: GetInterestRateTemplateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInterestRateTemplateDto>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling getInterestRateTemplateById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/interest-rate-templates/{template-id}`;
        urlPath = urlPath.replace(`{${"template-id"}}`, encodeURIComponent(String(requestParameters['templateId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInterestRateTemplateDtoFromJSON(jsonValue));
    }

    /**
     * Get existing interest rate template by id
     */
    async getInterestRateTemplateById(requestParameters: GetInterestRateTemplateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInterestRateTemplateDto> {
        const response = await this.getInterestRateTemplateByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get existing interest rate template by id and version id
     */
    async getInterestRateTemplateByIdAndVersionIdRaw(requestParameters: GetInterestRateTemplateByIdAndVersionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInterestRateTemplateDto>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling getInterestRateTemplateByIdAndVersionId().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling getInterestRateTemplateByIdAndVersionId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/interest-rate-templates/{template-id}/versions/{version-id}`;
        urlPath = urlPath.replace(`{${"template-id"}}`, encodeURIComponent(String(requestParameters['templateId'])));
        urlPath = urlPath.replace(`{${"version-id"}}`, encodeURIComponent(String(requestParameters['versionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInterestRateTemplateDtoFromJSON(jsonValue));
    }

    /**
     * Get existing interest rate template by id and version id
     */
    async getInterestRateTemplateByIdAndVersionId(requestParameters: GetInterestRateTemplateByIdAndVersionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInterestRateTemplateDto> {
        const response = await this.getInterestRateTemplateByIdAndVersionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get interest rate template with latest version by id
     */
    async getInterestRateTemplateWithLatestVersionByIdRaw(requestParameters: GetInterestRateTemplateWithLatestVersionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInterestRateTemplateDto>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling getInterestRateTemplateWithLatestVersionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/interest-rate-templates/{template-id}/versions/latest`;
        urlPath = urlPath.replace(`{${"template-id"}}`, encodeURIComponent(String(requestParameters['templateId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInterestRateTemplateDtoFromJSON(jsonValue));
    }

    /**
     * Get interest rate template with latest version by id
     */
    async getInterestRateTemplateWithLatestVersionById(requestParameters: GetInterestRateTemplateWithLatestVersionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInterestRateTemplateDto> {
        const response = await this.getInterestRateTemplateWithLatestVersionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
